<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />
    <site-device-query :options="filterSites" :query="query" />

    <el-select
      v-model="statusQuery"
      multiple
      size="small"
      collapse-tags
      style="width:160px;"
    >
      <el-option
        v-for="status in statuses"
        :key="status.value"
        :value="status.value"
        :label="status.label"
      />
    </el-select>

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
    <el-button
      :disabled="formatDataList.length === 0"
      type="success"
      icon="el-icon-download"
      size="small"
      @click="onDownloadBtnClick()"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        :span-method="spanMethod"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="站点" prop="siteName" width="100" />
        <el-table-column label="设备" prop="siteDeviceName" width="170" />
        <el-table-column label="填报日期" prop="opDate" width="100" align="center" />
        <el-table-column label="异常时段" prop="errTime" width="110" align="center">
          <template slot-scope="{row}">
            <div
              v-for="(times, index) in JSON.parse(row.errTime || '[]')"
              :key="index"
            >{{times[0].toString().padStart(2, '0')}}时{{times[1] === times[0] ? '' : ` 至 ${times[1].toString().padStart(2, '0')}时`}}</div>
          </template>
        </el-table-column>
        <el-table-column label="主要问题" prop="trouble" />
        <el-table-column label="解决计划" prop="solution" />
        <el-table-column label="填报人" prop="submitOrgName" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}"><span :log-status="row.status">{{statusMap[row.status].label}}</span></template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{row}">
            <div v-if="row.status === 2" class="table-operator-wrapper">
              <el-button type="warning" size="mini" @click="onReturnBtnClick(row)">退回</el-button>
              <el-button type="success" size="mini" @click="onSuccessBtnClick(row)">通过</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>
  <template #footer>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      background
      style="float: right;"
    >
    </el-pagination>
  </template>
</layout-content>
</template>

<script>
import BaseDateData from '../../../BaseDateData'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import statusMap from '../statusMap'
import DataWrapper from '../../../../components/Data/DataWrapper'
import CSVDownloader from '../../../../utils/CSVDownloader'

export default {
  name: 'OperationsLogAudit',
  routeInfo: {
    label: '日志审核',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {DataWrapper, DataTimeQuery},
  data () {
    return {
      query: {
        status: 2,
        siteDeviceIds: []
      },
      statusQuery: [2],
      currentQuery: Object.freeze({}),
      dataMap: Object.freeze({}),
      formatDataList: [],
      currentPage: 1,
      total: 0,
      pageSize: 100,
      list: []
    }
  },
  computed: {
    queryTimeStep: () => 1,
    statusMap: () => statusMap,
    statuses: () => Object.entries(statusMap).map(([key, value]) => ({
      value: key | 0,
      ...value
    })),
    filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {profileSites} = this

      if (profileSites.length === 0) {
        return []
      }

      let siteDeviceMap = profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      return Object.values(profileSites.reduce((map, site) => {
        let siteId = site.id

        if (siteDeviceMap.hasOwnProperty(siteId)) {
          map[siteId] = {
            value: siteId,
            label: site.name,
            children: siteDeviceMap[siteId].map(siteDevice => ({
              value: siteDevice.id,
              label: siteDevice.name
            }))
          }
        }

        return map
      }, {}))
    },
    days () {
      let {currentQuery} = this
      let beginTS = new Date(currentQuery.beginTime)
      let endTS = new Date(currentQuery.endTime)
      return Math.ceil((endTS - beginTS) / 86400000)
    },
    canNotSearch () {
      return this.query.siteDeviceIds.length === 0
    },
    // formatDataList () {
    //   let {profileSiteMap, profileSiteDeviceMap} = this
    //   return Object.values(this.dataMap).reduce((list, siteData) => Object.values(siteData).reduce((list, siteDeviceData) => siteDeviceData.reduce((list, data) => {
    //     list.push({
    //       siteName: profileSiteMap[data.siteId].name,
    //       siteDeviceName: profileSiteDeviceMap[data.siteDeviceId].name,
    //       ...data
    //     })
    //     return list
    //   }, list), list), [])
    // },
    rowSpanMap () {
      let lastSiteId
      let lastSiteDeviceId
      return this.list.reduce((map, data, index) => {
        let {siteId, siteDeviceId} = data

        if (siteId !== lastSiteId) {
          map.site[index] = true
          lastSiteId = siteId
        }

        if (siteDeviceId !== lastSiteDeviceId) {
          lastSiteDeviceId = siteDeviceId
          map.siteDevice[index] = true
        }

        return map
      }, {
        site: {},
        siteDevice: {}
      })
    }
  },
  methods: {
    setSiteDeviceIds (sites) {
      if (sites.length > 0) {
        let {query} = this

        if (query.siteDeviceIds.length === 0) {
          query.siteDeviceIds = sites[0].children.map(siteDevice => siteDevice.value)
        }

        setTimeout(() => {
          this.search()
        }, 0)
      }
    },
    search () {
      this.setCurrentQuery()
      this.getData()
    },
    setCurrentQuery () {
      let {query} = this
      query.status = this.statusQuery.reduce((or, n) => or | n, 0)
      // query.endTime = new Date(query.beginTime).format('YYYY/MM/DD 23:59:59')
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(query)))
    },
    getData () {
      let {currentQuery} = this
      this.changeLoadStatus(true)
      this.$api.Operations.getList({
        beginTime: currentQuery.beginTime,
        endTime: currentQuery.endTime,
        status: 1073741831,
        siteDeviceIds: currentQuery.siteDeviceIds
      }).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      let {currentQuery, profileSiteDeviceMap, days} = this
      let beginTS = new Date(currentQuery.beginTime).getTime()
      let dataTimes = []

      for (let i = 0; i < days; i++) {
        let date = new Date(beginTS + (i * 86400000))
        dataTimes.push({
          ts: date.getTime(),
          dataTime: date.format('YYYY/MM/DD')
        })
      }

      let dataMap = currentQuery.siteDeviceIds.reduce((map, siteDeviceId) => {
        let siteDevice = profileSiteDeviceMap[siteDeviceId]
        let {siteId} = siteDevice

        if (!map.hasOwnProperty(siteId)) {
          map[siteId] = {}
        }

        map[siteId][siteDeviceId] = dataTimes.map(dataTime => ({
          ts: dataTime.ts,
          opDate: dataTime.dataTime,
          siteId,
          siteDeviceId,
          status: 1
        }))

        return map
      }, {})

      dataList.forEach(data => {
        let {siteId, siteDeviceId} = data
        let index = (new Date(data.opDate + ' 00:00:00').getTime() - beginTS) / 86400000
        let tableData = dataMap[siteId][siteDeviceId][index]
        tableData.id = data.id
        tableData.errTime = data.errTime
        tableData.solution = data.solution
        tableData.trouble = data.trouble
        tableData.submitOrgName = data.submitOrgName
        tableData.status = data.status
      })

      // this.dataMap = Object.freeze(dataMap)
      let {profileSiteMap} = this
      // let data = Object.values(dataMap).reduce((list, siteData) => Object.values(siteData).reduce((list, siteDeviceData) => siteDeviceData.reduce((list, data) => {
      //   list.push({
      //     siteName: profileSiteMap[data.siteId].name,
      //     siteDeviceName: profileSiteDeviceMap[data.siteDeviceId].name,
      //     ...data
      //   })
      //   return list
      // }, list), list), [])

      let {status} = this.query
      let siteDeviceData = Object.values(dataMap).map(el => Object.values(el)).flat(Infinity).filter(data => data.status & status)
      let data = siteDeviceData.map(el => {
        return {
          ...el,
          siteName: profileSiteMap[el.siteId].name,
          siteDeviceName: profileSiteDeviceMap[el.siteDeviceId].name
        }
      })

      if ((this.total = data.length) > this.pageSize) {
        let list = []
        for (let index = 0; index < this.pageSize; index++) {
          list.push(data[index])
        }
        this.list = list
        this.dataMap = list.reduce((map, el) => {
          if (!map[el.siteId]) {
            map[el.siteId] = {}
          }

          if (!map[el.siteId][el.siteDeviceId]) {
            map[el.siteId][el.siteDeviceId] = []
          }

          map[el.siteId][el.siteDeviceId].push(el)
          return map
        }, {})
      } else {
        this.list = data
        this.dataMap = data.reduce((map, el) => {
          if (!map[el.siteId]) {
            map[el.siteId] = {}
          }

          if (!map[el.siteId][el.siteDeviceId]) {
            map[el.siteId][el.siteDeviceId] = []
          }

          map[el.siteId][el.siteDeviceId].push(el)
          return map
        }, {})
      }

      this.formatDataList = data
    },
    currentChangePage (list, currentPage) {
      let from = (currentPage - 1) * this.pageSize
      let to = currentPage * this.pageSize
      this.list = []

      let data = []
      for (; from < to; from++) {
        if (list[from]) {
          data.push(list[from])
        }
      }
      this.list = data
      this.dataMap = data.reduce((map, el) => {
        if (!map[el.siteId]) {
          map[el.siteId] = {}
        }

        if (!map[el.siteId][el.siteDeviceId]) {
          map[el.siteId][el.siteDeviceId] = []
        }

        map[el.siteId][el.siteDeviceId].push(el)
        return map
      }, {})
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.currentChangePage(this.formatDataList, currentPage)
    },
    spanMethod ({row, columnIndex, rowIndex}) {
      let {rowSpanMap, dataMap} = this
      let {siteId, siteDeviceId} = row

      switch (columnIndex) {
        case 0:
          let siteColumnSpan = -rowSpanMap.site[rowIndex]

          return {
            rowspan: siteColumnSpan & (Object.values(dataMap[siteId]).flat().length),
            colspan: 1
          }
        case 1:
          let siteDeviceColumnSpan = -rowSpanMap.siteDevice[rowIndex]

          return {
            rowspan: siteDeviceColumnSpan & (dataMap[siteId][siteDeviceId].length),
            colspan: 1
          }
      }
    },
    onSearchBtnClick () {
      this.search()
    },
    onReturnBtnClick (data) {
      this.changeLoadStatus(true)
      this.$api.Operations.return([data.id]).then(this.getData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onSuccessBtnClick (data) {
      this.changeLoadStatus(true)
      this.$api.Operations.submit([data.id]).then(this.getData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime}, formatDataList, statusMap} = this
      let csvName = `${new Date(beginTime).format('YYYY年MM月DD日')}_${new Date(endTime).format('YYYY年MM月DD日')}日志审核记录`
      let headerColumns = this.$refs['table'].columns.map(el => {
        if (el.label !== '操作') {
          return el.label
        }
      }).filter(Boolean)
      let data = formatDataList.map(el => {
        let errTime = JSON.parse(el.errTime || '[]').map(el => {
          return `${el[0].toString().padStart(2, '0')}时${el[1] === el[0] ? '' : (' 至 ' + el[1].toString().padStart(2, '0') + '时')}`
        }).join(',')
        return [
          el.siteName,
          el.siteDeviceName,
          el.opDate,
          errTime,
          el.trouble,
          el.solution,
          el.submitOrgName,
          statusMap[el.status].label
        ]
      })

      CSVDownloader([headerColumns, ...data], csvName)
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (newVal) {
        if (newVal.length > 0) {
          setTimeout(() => {
            this.setSiteDeviceIds(newVal)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[log-status="1"] {
  color: #F56C6C;
}

[log-status="1073741824"] {
  color: #E6A23C;
}

[log-status="4"] {
  color: #67C23A;
}
</style>



// WEBPACK FOOTER //
// src/views/08Operations/02Log/02Audit/index.vue